export default "__VITE_ASSET__StXveHVp__"